import axios from "axios";

const configJson = require("../config.json");
const APIBASE = new URL(configJson.apiBase);
const APIURL = APIBASE + "api/baskets/";

/**
 * Request to add documents to a basket.
 *
 * @param basketId The id of the basket to add documents to.
 * @param resources The documents to be added to the basket.
 * @returns {Promise<AxiosResponse<any>>}
 */
export default async function basketAddDocumentRequest(basketId, resources) {
  return await axios.post(
    APIURL + basketId + "/add",
    {
      resources: resources
    },
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("Bearer")
      }
    }
  );
}
